import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import OnlineStatus from '../OnlineStatus';
import './index.scss';
import { formatStatusText } from './formatStatusText';

const OnlineStatusExpanded = ({ online, lastSeen, className }) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.resolvedLanguage || i18n.language;

    const statusText = useMemo(
        () => formatStatusText({ online, lastSeen, locale, t }),
        [online, lastSeen, locale, t],
    );

    const labelText = useMemo(
        () => t('online-status-expanded__label', { status: statusText }),
        [statusText, t],
    );

    return (
        <div className={`online-status-expanded${className ? ` ${className}` : ''}`}>
            <OnlineStatus online={online} lastSeen={lastSeen} />
            <span className="online-status-expanded__label" aria-label={labelText} title={labelText}>
                {statusText}
            </span>
        </div>
    );
};

OnlineStatusExpanded.propTypes = {
    online: PropTypes.bool,
    lastSeen: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
    ]),
    className: PropTypes.string,
};

OnlineStatusExpanded.defaultProps = {
    online: false,
    lastSeen: null,
    className: undefined,
};

export default OnlineStatusExpanded;
